<app-cms-top-bar></app-cms-top-bar>
<div id="wrapper">
    <app-cms-side-bar [active]="'user-management'"></app-cms-side-bar>
    <div id="content-wrapper">

        <div class="container-fluid">
            <p class="title">การจัดการผู้ใช้งาน</p>

            <!-- Form  -->
            <div class="card mb-3">
                <div class="card-body p-3">
                    <div class="table-responsive" style="overflow-x: hidden;">
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-2" style="text-align: center;">
                                <button type="button" class="btn btn-primary" (click)="create_users_page()">สร้าง</button>
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-1">
                                <p style="text-align: right; padding-top: 7px;">ค้นหา :</p>
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-6">
                                <input type="text" class="form-control" aria-describedby="emailHelp">
                            </div>
                            <div class="col-sm-6 col-md-3 col-lg-2">
                                <button type="button" class="btn btn-primary">ค้นหา</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-12" style="padding: 2%; text-align: center;">
                                <table class="table table-bordered">
                                    <thead class="head-tb">
                                        <tr>
                                            <th style="width: 75px;">ลำดับที่</th>
                                            <th>Uesrname</th>
                                            <th>ชื่อ</th>
                                            <th>นามสกุล</th>
                                            <th>Email</th>
                                            <th>ตำแหน่ง</th>
                                            <th>เบอร์โทร</th>
                                            <th colspan="2">ตัวเลือก</th>
                                        </tr>
                                    </thead>
                                    <tbody class="line-tb">
                                        <tr *ngFor="let list of pageOfItems; let i = index">
                                            <td>{{list.number}}</td>
                                            <td>{{list.username}}</td>
                                            <td>{{list.fname}}</td>
                                            <td>{{list.lname}}</td>
                                            <td style="text-overflow: ellipsis;">{{list.email}}</td>
                                            <td>{{list.role}}</td>
                                            <td>{{list.tel}}</td>
                                            <td class="d-flex justify-content-around">
                                                <button type="button" class="btn btn-outline-success btn-sm"
                                                    style="width: 30px;"
                                                    (click)="edit_user_page(list.number-1)"><i
                                                        class="far fa-edit"></i></button>

                                                <button type="button" class="btn btn-outline-danger btn-sm"
                                                    style="width: 30px;"><i class="fa fa-trash"></i></button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- Pagination -->
                        <div class="row">
                            <div class="col-sm-6 col-md-3 col-lg-12 text-center">
                                <ul class="pagination justify-content-center">
                                    <jw-pagination [items]="items" (changePage)="onChangePage($event)"></jw-pagination>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <router-outlet></router-outlet>
        </div>
    </div>
</div>